// TrackIT wordmark rendered in the Danone One corporate font (live <text>, not
// the brand-pack's Nunito-outlined artwork) with the signature "delivery track"
// line - one honest dip, then the climb onto the live cyan node.
//
// `textLength` pins the wordmark to a fixed width so the track geometry lines up
// regardless of the exact Danone One glyph metrics. `animated` adds the
// draw-on signature (used on the login screen); it respects reduced-motion.

export default function TrackitLogo({
  className = 'h-9',
  animated = false,
}: {
  className?: string
  animated?: boolean
}) {
  return (
    <svg
      viewBox="0 0 210 56"
      className={`${animated ? 'trackit-logo--animated ' : ''}${className}`}
      role="img"
      aria-label="TrackIT"
    >
      <text
        className="trackit-logo__wm"
        x="2"
        y="40"
        textLength="172"
        lengthAdjust="spacingAndGlyphs"
        fontFamily="'Danone One', 'Inter', sans-serif"
        fontWeight="700"
        fontSize="42"
        fill="#005EB8"
      >
        TrackIT
      </text>
      <polyline
        className="trackit-logo__line"
        points="2,50 64,50 84,53.5 104,50 178,50 200,32"
        fill="none"
        stroke="#00ACED"
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {animated && (
        <circle
          className="trackit-logo__ping"
          cx="200"
          cy="32"
          r="6"
          fill="none"
          stroke="#00ACED"
          strokeWidth="2"
        />
      )}
      <circle className="trackit-logo__node" cx="200" cy="32" r="6" fill="#00ACED" />
    </svg>
  )
}

/**
 * The app icon: the delivery track and its live node on a Danone blue tile,
 * the same artwork as the favicon (public/brand/trackit-icon-192.png), drawn
 * as SVG so it stays sharp at any size. Used where there is no room for the
 * wordmark, like the folded sidebar.
 */
export function TrackitMark({ className = 'h-9 w-9' }: { className?: string }) {
  return (
    <svg viewBox="0 0 512 512" className={className} role="img" aria-label="TrackIT">
      <rect width="512" height="512" rx="116" fill="#005EB8" />
      <g transform="translate(11.4 -1) scale(0.95)">
        <polyline
          points="118,356 214,260 268,314 384,198"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="46"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="384" cy="198" r="36" fill="#00ACED" />
      </g>
    </svg>
  )
}
